<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baRecipeDrugRecord:page')">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="7" :sm="24">
                <a-form-item label="药品编码">
                  <a-input v-model="queryParam.medicineCode" allow-clear placeholder="请输入药品编码"/>
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="24">
                <a-form-item label="药品名称">
                  <a-input v-model="queryParam.medicineName" allow-clear placeholder="请输入药品名称"/>
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="24">
                <a-form-item label="日期">
                  <a-range-picker
                    style="width: 100%"
                    @change="onChangeDate"
                  />
                </a-form-item>
              </a-col>

            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="类型  0：发药  1：退药">
                <a-input v-model="queryParam.type" allow-clear placeholder="请输入类型  0：发药  1：退药"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="处方流水号(显示在缴费单上)">
                <a-input v-model="queryParam.recipeNo" allow-clear placeholder="请输入处方流水号(显示在缴费单上)"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="数量">
                  <a-input v-model="queryParam.medicineNum" allow-clear placeholder="请输入数量"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="药品类型  0：西药/中成药  1：中药">
                  <a-input v-model="queryParam.medicineType" allow-clear placeholder="请输入药品类型  0：西药/中成药  1：中药"/>
                </a-form-item>
              </a-col>
        
              <a-col :md="8" :sm="24">
                <a-form-item label="规格">
                  <a-input v-model="queryParam.specification" allow-clear placeholder="请输入规格"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="剂量单位">
                  <a-input v-model="queryParam.mediUnit" allow-clear placeholder="请输入剂量单位"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="创建时间戳">
                  <a-date-picker style="width: 100%" placeholder="请选择创建时间戳" v-model="queryParam.ctstampDate" @change="onChangectstamp"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="删除标识（0-否，1-是）">
                  <a-input v-model="queryParam.deleteFlag" allow-clear placeholder="请输入删除标识（0-否，1-是）"/>
                </a-form-item>
              </a-col>
            </template> -->
            <a-col :md="3" :sm="24" >
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)" >查询</a-button>
                <!-- <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button> -->
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowKey="(record) => record.id"
        :rowSelection="options.rowSelection"
      >
        <!-- <template class="table-operator" slot="operator" v-if="hasPerm('baRecipeDrugRecord:add')" >
          <a-button type="primary" v-if="hasPerm('baRecipeDrugRecord:add')" icon="plus" @click="$refs.addForm.add()">新增处方药品发药退药记录表</a-button>
          <a-button type="danger" :disabled="selectedRowKeys.length < 1" v-if="hasPerm('baRecipeDrugRecord:delete')" @click="batchDelete"><a-icon type="delete"/>批量删除</a-button>
          <x-down
            v-if="hasPerm('baRecipeDrugRecord:export')"
            ref="batchExport"
            @batchExport="batchExport"
          />
        </template> -->
        <span  slot="type" slot-scope="text, record"> 
          <span v-if="record.type == '1'" style="color: red;">
            退药
          </span>
          <span v-else>发药</span>
            <!-- {{record.type == '0'? '发药' : record.type == '1'? '退药' : '' }} -->
        </span>
        <span slot="action" slot-scope="text, record">
          <a v-if="hasPerm('baRecipeDrugRecord:edit')" @click="$refs.editForm.edit(record)">编辑</a>
          <a-divider type="vertical" v-if="hasPerm('baRecipeDrugRecord:edit') & hasPerm('baRecipeDrugRecord:delete')"/>
          <a-popconfirm v-if="hasPerm('baRecipeDrugRecord:delete')" placement="topRight" title="确认删除？" @confirm="() => singleDelete(record)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>
<script>
  import { STable, XDown } from '@/components'
  import moment from 'moment'
  import { baRecipeDrugRecordPage, baRecipeDrugRecordDelete, baRecipeDrugRecordExport } from '@/api/modular/interhospital/barecipedrugrecord/baRecipeDrugRecordManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'
  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },
    data () {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
              title: '时间',
              align: 'center',
              dataIndex: 'ctstamp'
          },
          {
            title: '处方编号',
            align: 'center',
            dataIndex: 'recipeNo'
          },
    
          // {
          //   title: '药品类型  0：西药/中成药  1：中药',
          //   align: 'center',
          //   dataIndex: 'medicineType'
          // },
          {
            title: '药品编码',
            align: 'center',
            dataIndex: 'medicineCode'
          },
          {
            title: '药品名称',
            align: 'center',
            dataIndex: 'medicineName'
          },
          {
            title: '规格',
            align: 'center',
            dataIndex: 'specification'
          },
          {
            title: '发药数量',
            align: 'center',
            dataIndex: 'medicineNum'
          },
          {
            title: '单位',
            align: 'center',
            dataIndex: 'mediUnit'
          },
          {
            title: '类型',
            align: 'center',
            dataIndex: 'type',
            scopedSlots: { customRender: 'type' },
          },
          // {
          //   title: '创建时间戳',
          //   align: 'center',
          //   dataIndex: 'ctstamp'
          // },
          // {
          //   title: '更新时间戳',
          //   align: 'center',
          //   dataIndex: 'utstamp'
          // },
          // {
          //   title: '删除标识（0-否，1-是）',
          //   align: 'center',
          //   dataIndex: 'deleteFlag'
          // }
        ],
        tstyle: { 'padding-bottom': '0px', 'margin-bottom': '10px' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baRecipeDrugRecordPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },
    // created () {
    //   if (this.hasPerm('baRecipeDrugRecord:edit') || this.hasPerm('baRecipeDrugRecord:delete')) {
    //     this.columns.push({
    //       title: '操作',
    //       width: '150px',
    //       dataIndex: 'action',
    //       scopedSlots: { customRender: 'action' }
    //     })
    //   }
    // },
    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate () {
        const queryParamctstamp = this.queryParam.ctstampDate
        if (queryParamctstamp != null) {
            this.queryParam.ctstamp = moment(queryParamctstamp).format('YYYY-MM-DD')
            if (queryParamctstamp.length < 1) {
                delete this.queryParam.ctstamp
            }
        }
        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },
      /**
       * 单个删除
       */
      singleDelete (record) {
        const param = [{ 'id': record.id }]
        this.baRecipeDrugRecordDelete(param)
      },
      /**
       * 批量删除
       */
      batchDelete () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        this.baRecipeDrugRecordDelete(paramIds)
      },
      baRecipeDrugRecordDelete (record) {
        baRecipeDrugRecordDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      /**
       * 批量导出
       */
      batchExport () {
        const paramIds = this.selectedRowKeys.map((d) => {
            return { 'id': d }
        })
        baRecipeDrugRecordExport(paramIds).then((res) => {
            this.$refs.batchExport.downloadfile(res)
        })
      },
      handleOk () {
        this.$refs.table.refresh()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      onChangeDate(date, dateString) {
        console.log('onChangeDate', date, dateString)
        this.queryParam.startTime = dateString[0]
        this.queryParam.endTime = dateString[1]
      },
    }
  }
</script>
<style lang="less">
  .table-operator {
    margin-bottom: 18px;
  }
  button {
    margin-right: 8px;
  }
</style>
